function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import { transparentize } from 'polished';
import { useTranslation } from 'react-i18next';
import { Button, DropableContainer, Dropdown, DropdownList, DropdownListContainer, Input, Label, MousePositionedTooltip, KEYBOARD_KEYS } from '@keen.io/ui-core';
import { BodyText, Headline } from '@keen.io/typography';
import { colors } from '@keen.io/colors';
import { ChartEvents } from '@keen.io/charts';
import { extractFormatterType } from '@keen.io/charts-utils';
import { useKeypress } from '@keen.io/react-hooks';
import { Icon } from '@keen.io/icons';
import SectionTitle from '../../../SectionTitle';
import { AppContext } from '../../../../contexts';
import { InputWrapper, SettingsColumnLeft, SettingsColumnRight, Container, ControlContainer, SelectColumnInfo, FormatInfo, TitleWrapper, TitleActions, DropdownInfo, SelectColumnInfoWrapper, InfoIconWrapper } from './FormatTableSettings.styles';
import { DATA_TYPES, DataTypes } from './constants';
import { DateTimeFormatter, NumericFormatter, StringFormatter } from '../Formatters';

var FormatTableSettings = function FormatTableSettings(_ref) {
  var onUpdateFormatValue = _ref.onUpdateFormatValue,
      onUpdateColumnName = _ref.onUpdateColumnName,
      columnsNamesMapping = _ref.columnsNamesMapping;
  var chartEventsRef = useRef();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(AppContext),
      pubSub = _useContext.pubSub,
      modalContainer = _useContext.modalContainer;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownOpen = _useState2[0],
      setDropdownOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      dataType = _useState4[0],
      setDataType = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedColumns = _useState6[0],
      setSelectedColumns = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      formatValue = _useState8[0],
      setFormatValue = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      selectionIndex = _useState10[0],
      setIndex = _useState10[1];

  var TranslatedDataTypes = DATA_TYPES.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return {
      label: t(label),
      value: value
    };
  });

  var selectedColumnsAreEqual = function selectedColumnsAreEqual(selectedColumns) {
    var _selectedColumns = _slicedToArray(selectedColumns, 1),
        firstSelectedColumn = _selectedColumns[0];

    return selectedColumns.every(function (column) {
      return column.dataType === firstSelectedColumn.dataType;
    });
  };

  var onChartEvent = function onChartEvent(tableEvent) {
    if (tableEvent.eventName === '@table/columns-selected') {
      var _selectedColumns2 = tableEvent.meta.selection;
      setSelectedColumns(_selectedColumns2);
      if (_selectedColumns2.length === 0) return setDataType(null);

      var _selectedColumns3 = _slicedToArray(_selectedColumns2, 1),
          firstSelectedColumn = _selectedColumns3[0];

      if (_selectedColumns2.length === 1) {
        setFormatValue(firstSelectedColumn.formatter);

        if (firstSelectedColumn.formatter) {
          return setDataType(extractFormatterType(firstSelectedColumn.formatter));
        }

        return setDataType(firstSelectedColumn.dataType);
      }

      setFormatValue(null);
      var allColumnTypesAreEqual = selectedColumnsAreEqual(_selectedColumns2);

      if (allColumnTypesAreEqual) {
        return setDataType(firstSelectedColumn.dataType);
      }

      setDataType(DataTypes.notDefined);
    }

    if (tableEvent.eventName === '@table/deselect-columns') {
      setSelectedColumns([]);
      setDataType(null);
    }
  };

  var deselectColumns = function deselectColumns() {
    chartEventsRef.current.publish({
      eventName: '@table/deselect-columns'
    });
  };

  useEffect(function () {
    chartEventsRef.current = new ChartEvents({
      pubsub: pubSub
    });
    var chartEventsUnsubscribe = chartEventsRef.current.subscribe(onChartEvent);
    return function () {
      deselectColumns();
      chartEventsUnsubscribe();
    };
  }, []);
  useEffect(function () {
    if (dropdownOpen) {
      var iconIndex = TranslatedDataTypes.findIndex(function (_ref3) {
        var value = _ref3.value;
        return value === dataType;
      });
      var index = iconIndex > 0 ? iconIndex : 0;
      setIndex(index);
    }

    return function () {
      setIndex(null);
    };
  }, [dropdownOpen]);
  var keyboardHandler = useCallback(function (_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        var value = TranslatedDataTypes[selectionIndex].value;
        setDataType(value);
        setDropdownOpen(false);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (selectionIndex < TranslatedDataTypes.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setDropdownOpen(false);
        break;
    }
  }, [selectionIndex, TranslatedDataTypes]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: dropdownOpen,
    eventListenerDependencies: [dropdownOpen, selectionIndex, TranslatedDataTypes]
  });

  var onUpdateFormat = function onUpdateFormat(value) {
    var formatters = {};
    selectedColumns.forEach(function (column) {
      formatters[column.name] = value;
    });
    onUpdateFormatValue(formatters);
  };

  var selectedDataTypeOption = TranslatedDataTypes.find(function (type) {
    return type.value === dataType;
  });
  return React.createElement(Container, null, !dataType ? React.createElement(SelectColumnInfoWrapper, null, React.createElement(SelectColumnInfo, null, React.createElement(InfoIconWrapper, null, React.createElement(Icon, {
    type: "click-solid",
    width: 21,
    height: 23,
    fill: colors.green[500]
  })), React.createElement(BodyText, {
    variant: "body1",
    color: colors.green[500]
  }, t('widget_customization_format_value_settings.click_on_columns_to_select_data')))) : React.createElement(React.Fragment, null, React.createElement(SettingsColumnLeft, null, React.createElement(TitleWrapper, null, React.createElement(Headline, {
    variant: "h4"
  }, t('widget_customization_format_value_settings.column_name_and_data_type')), React.createElement(TitleActions, null, React.createElement(BodyText, {
    variant: "body2",
    color: transparentize(0.3, colors.black[100])
  }, "(", t('widget_customization_format_value_settings.selected'), ":", ' ', selectedColumns.length, ")"), React.createElement(Button, {
    size: "small",
    style: "outline",
    variant: "secondary",
    onClick: deselectColumns
  }, t('widget_customization_format_value_settings.deselect_all')))), React.createElement(MousePositionedTooltip, {
    isActive: selectedColumns.length > 1,
    tooltipPortal: modalContainer,
    tooltipTheme: "dark",
    renderContent: function renderContent() {
      return React.createElement(BodyText, {
        variant: "body2",
        color: colors.white[500]
      }, t('widget_customization_format_value_settings.select_the_single_column_to_change_the_name'));
    }
  }, React.createElement(ControlContainer, {
    isDisabled: selectedColumns.length > 1
  }, React.createElement(Label, {
    variant: "secondary"
  }, t('widget_customization_format_value_settings.column_name')), React.createElement(InputWrapper, null, React.createElement(Input, {
    "data-testid": "column-name-input",
    variant: "solid",
    placeholder: selectedColumns.length > 1 ? '' : selectedColumns[0].name,
    value: selectedColumns.length > 1 ? '' : columnsNamesMapping[selectedColumns[0].name] || '',
    onChange: function onChange(e) {
      return onUpdateColumnName(selectedColumns[0].name, e.target.value);
    }
  })))), React.createElement(ControlContainer, null, React.createElement(Label, {
    variant: "secondary"
  }, t('widget_customization_format_value_settings.data_type')), React.createElement(InputWrapper, null, React.createElement(DropableContainer, {
    variant: "secondary",
    onClick: function onClick() {
      return setDropdownOpen(!dropdownOpen);
    },
    isActive: dropdownOpen,
    placeholder: t('widget_customization_format_value_settings.select_data_type'),
    value: selectedDataTypeOption && selectedDataTypeOption.value,
    dropIndicator: true,
    onDefocus: function onDefocus() {
      return setDropdownOpen(false);
    }
  }, selectedDataTypeOption && selectedDataTypeOption.label), React.createElement(Dropdown, {
    isOpen: dropdownOpen
  }, React.createElement(DropdownInfo, null, React.createElement(BodyText, {
    variant: "body3",
    fontWeight: 400
  }, t('widget_customization_format_value_settings.you_will_map_property'))), React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 150
  }, function (activeItemRef) {
    return React.createElement("div", null, React.createElement(DropdownList, {
      ref: activeItemRef,
      items: TranslatedDataTypes,
      setActiveItem: function setActiveItem(_ref4) {
        var value = _ref4.value;
        return TranslatedDataTypes[selectionIndex] && TranslatedDataTypes[selectionIndex].value === value;
      },
      onClick: function onClick(e, item) {
        setDataType(item.value);
        setDropdownOpen(!dropdownOpen);
      }
    }));
  })))), React.createElement(BodyText, {
    variant: "body2",
    color: transparentize(0.5, colors.black[100])
  }, t('widget_customization_format_value_settings.select_multiple_columns_to_apply_formatting'))), React.createElement(SettingsColumnRight, null, React.createElement(SectionTitle, {
    title: t('widget_customization_format_value_settings.values_format')
  }), dataType === DataTypes.string && React.createElement(StringFormatter, {
    formatValue: formatValue,
    onUpdateFormatValue: onUpdateFormat
  }), dataType === DataTypes.number && React.createElement(NumericFormatter, {
    formatValue: formatValue,
    onUpdateFormatValue: onUpdateFormat
  }), dataType === DataTypes.dateTime && React.createElement(DateTimeFormatter, {
    formatValue: formatValue,
    onUpdateFormatValue: onUpdateFormat
  }), dataType === DataTypes.boolean && React.createElement(FormatInfo, null, React.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500]
  }, t('widget_customization_format_value_settings.boolean_not_supported'))), dataType === DataTypes.notDefined && React.createElement(FormatInfo, {
    "data-testid": "columns-format-notification"
  }, React.createElement(BodyText, {
    variant: "body2",
    color: colors.blue[500]
  }, t('widget_customization_format_value_settings.selected_columns_use_different_data_type'), React.createElement("br", null), t('widget_customization_format_value_settings.specify_data_type_to_apply_proper_formatting'))))));
};

export default FormatTableSettings;